import { useState, useRef, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Loader } from "rsuite";
import Select from "react-select";
import Swal from "sweetalert2";
import { MaterialReactTable } from "material-react-table";
import { axInst } from "../../../Components/Login/Service";
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
} from "@tanstack/react-table";

const fetchSavedData = async (body, apiEndpoint) => {
  try {
    const res = await axInst.post(apiEndpoint, body);
    return Array.isArray(res.data) ? res.data : [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

const DealerDataUpload = () => {
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [uploadResponse, setUploadResponse] = useState(null);
  const [isTableVisible, setIsTableVisible] = useState(false);
  const [isErrorTableVisible, setIsErrorTableVisible] = useState(false);
  const { filter, submitted } = useSelector((e) => e.filtersDealerReview);
  const [loading, setLoading] = useState(false);
  // const [isFormVisible, setFormVisible] = useState(false);
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState("");
  const [apiEndpoint, setApiEndpoint] = useState("dealer-review/user_csvdata");
  const [downloadFile, setDownloadFile] = useState(
    "SampleDealerReviewFiles/SampleWar.csv",
  );
  const [errorColumns, setErrorColumns] = useState([]);
  const [uploadAllowed, setUploadAllowed] = useState(false);

  const {
    data: savedData = [],
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["upload", submitted, apiEndpoint],
    queryFn: () => fetchSavedData(filter, apiEndpoint),
    cacheTime: 0,
    staleTime: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axInst.post("/user_upload");
        const fetchedOptions = res.data?.Restriction || [];
        setOptions(fetchedOptions);

        if (fetchedOptions.length > 0) {
          const firstOption = fetchedOptions[0];
          setSelected(firstOption);
          handleChange({ target: { value: firstOption } }); // ✅ trigger uploadAllowed logic
        }
      } catch (error) {
        console.error(error);
        setOptions([]);
        setSelected("");
      }
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    setUploadResponse(null);
    let value = e.target.value;
    setSelected(value);

    let endpoint = "";
    let file = "";
    let isUploadAllowed = true;

    switch (value) {
      case "WAR Score":
        endpoint = "dealer-review/user_csvdata";
        file = "SampleDealerReviewFiles/SampleWar.csv";
        const currentMonth = new Date().getMonth(); // Jan = 0
        isUploadAllowed = currentMonth === 4 || currentMonth === 7; // May or August
        break;

      case "SAR Score":
        endpoint = "dealer-review/sar_upload";
        file = "SampleDealerReviewFiles/SampleSar.csv";
        isUploadAllowed = true;
        break;

      case "VAS Penetration":
        endpoint = "dealer-review/VAS_data_upload";
        file = "SampleDealerReviewFiles/SampleVAS.csv";
        isUploadAllowed = true;
        break;

      case "CPSC Score":
        endpoint = "dealer-review/cpsc_data_upload";
        file = "SampleDealerReviewFiles/SampleCPSC.csv";
        isUploadAllowed = true;
        break;

      case "Samridhi Score":
        endpoint = "dealer-review/samridhi_data_upload";
        file = "SampleDealerReviewFiles/SampleSamridhi.csv";
        isUploadAllowed = true;
        break;
      case "PSF Score":
        endpoint = "dealer-review/psf_data_upload";
        file = "SampleDealerReviewFiles/SamplePSF.csv";
        isUploadAllowed = true;
        break;
      case "NPS Score":
        endpoint = "dealer-review/nps_data_upload";
        file = "SampleDealerReviewFiles/SampleNPS.csv";
        isUploadAllowed = true;
        break;
      case "DSAT Score":
        endpoint = "dealer-review/dsat_data_upload";
        file = "SampleDealerReviewFiles/SampleDSAT.csv";
        isUploadAllowed = true;
        break;
      case "CPTC Score":
        endpoint = "dealer-review/cptc_data_upload";
        file = "SampleDealerReviewFiles/SampleCPTC.csv";
        isUploadAllowed = true;
        break;
      case "CES Score":
        endpoint = "dealer-review/ces_data_upload";
        file = "SampleDealerReviewFiles/SampleCES.csv";
        isUploadAllowed = true;
        break;
      case "DSE Talent Grid":
        endpoint = "dealer-review/dse_user_csv_data_upload";
        file = "SampleDealerReviewFiles/SampleDSE.csv";
        isUploadAllowed = true;
        break;
      case "Manpower Data Mapping":
        endpoint = "dealer-review/manpower_mappings_data_upload ";
        file = "SampleDealerReviewFiles/SampleManpowerMapping.csv";
        isUploadAllowed = true;
        break;
      case "Service SAR Score":
        endpoint = "collbax-service/sar-upload ";
        file = "SampleDealerReviewFiles/Sample_Upload_Service_Collabx_SAR.xlsx";
        isUploadAllowed = true;
        break;
      case "Service CPSC Score":
        endpoint = "collbax-service/cpsc-upload";
        file =
          "SampleDealerReviewFiles/Sample_Upload_Service_Collabx_CPSC.xlsx";
        isUploadAllowed = true;
        break;
      case "Service CES Score":
        endpoint = "collbax-service/ces-upload";
        file =
          "SampleDealerReviewFiles/Sample_Upload_Service_Collabx_CES_Upload.xlsx";
        isUploadAllowed = true;
        break;
      case "Service CPTC Score":
        endpoint = "collbax-service/cptc-upload";
        file =
          "SampleDealerReviewFiles/Sample_Upload_Service_collabx_CPTC.xlsx";
        isUploadAllowed = true;
        break;
      case "Service IPTV Alert":
        endpoint = "collbax-service/iptv-upload";
        file = "SampleDealerReviewFiles/sample_serviceCollabax_Iptv.xlsx";
        isUploadAllowed = true;
        break;
      case "Service CPTC Score":
        endpoint = "collbax-service/cptc-upload";
        file = "SampleDealerReviewFiles/SampleManpowerMapping.csv";
        isUploadAllowed = true;
        break;

      default:
        endpoint = "";
        file = "";
        isUploadAllowed = false;
        break;
    }

    setApiEndpoint(endpoint);
    setDownloadFile(file);
    setUploadAllowed(isUploadAllowed);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    const maxSize = 5 * 1024 * 1024;

    if (selectedFile && selectedFile.size > maxSize) {
      alert("File size exceeds 5MB. Please upload a smaller file.");
      e.target.value = null;
      return;
    }
    setFile(selectedFile);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      alert("Please select a file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);

    try {
      const res = await axInst.put(apiEndpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.status === 200) {
        setUploadResponse(null);

        const swalRes = await Swal.fire({
          title: "File Uploaded Successfully !!",
          icon: "success",
          confirmButtonText: "OK",
          didOpen: () => {
            document.querySelector(".swal2-confirm").style.backgroundColor =
              "green";
            document.querySelector(".swal2-confirm").style.color = "white";
          },
        });

        if (swalRes.isConfirmed) {
          setIsTableVisible(true);
          refetch();
        }
      }
    } catch (error) {
      const status = error?.response?.status;
      const data = error?.response?.data;
      console.error("Error saving targets:", error);
      let title = "Failed to Upload Data !!";
      let html = "";

      if (status === 400 && data) {
        setUploadResponse(data);

        if (data?.unprivileged_dealer_found) {
          html =
            '<div style="font-size: 0.9rem; margin-top: 3px;">Dealer Code Access Denied</div>';
        } else if (data?.ERROR) {
          html = `<div style="font-size: 1.5rem; margin-top: 2px; color: red;">${data.ERROR}</div>`;
        }
      } else {
        setUploadResponse(null);
      }

      const swalRes = await Swal.fire({
        title: title,
        html: html,
        icon: "error",
        confirmButtonText: "OK",
        didOpen: () => {
          document.querySelector(".swal2-confirm").style.backgroundColor =
            "red";
          document.querySelector(".swal2-confirm").style.color = "white";
        },
      });

      if (swalRes.isConfirmed) {
        setIsErrorTableVisible(true);
      }
    } finally {
      setLoading(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = null;
      }
      setFile(null);
    }
  };

  const handleDownload = () => {
    if (!downloadFile) return;

    const link = document.createElement("a");
    link.href = `/${downloadFile}`; // Assuming the file is in the public folder
    link.download = downloadFile;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Generate columns dynamically
  const columns =
    savedData.length > 0
      ? Object.keys(savedData[0]).map((key) => ({
          accessorKey: key,
          header: key
            .replace(/_/g, " ")
            .toLowerCase()
            .replace(/\b\w/g, (c) => c.toUpperCase()),
          size: 20,
        }))
      : [];

  useEffect(() => {
    if (uploadResponse?.incorrect_uploaded_data?.length > 0) {
      const errorColumns = Object.keys(
        uploadResponse.incorrect_uploaded_data[0],
      ).map((key) => ({
        accessorKey: key,
        header: key
          .replace(/_/g, " ") // Replace underscores with spaces
          .toLowerCase() // Convert the whole string to lowercase
          .replace(/^\w/, (c) => c.toUpperCase()), // Capitalize first letter
      }));
      setErrorColumns(errorColumns);
    } else {
      setErrorColumns([]);
    }
  }, [uploadResponse]);

  const errorTable = useReactTable({
    data: uploadResponse?.incorrect_uploaded_data || [],
    columns: errorColumns,
    getCoreRowModel: getCoreRowModel(),
  });
  return (
    <div className="p-3 sm:p-4">
      {/* Top Controls */}
      <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-5">
        <div className="w-full sm:w-auto flex justify-center">
          <Select
            value={
              selected
                ? {
                    value: selected,
                    label: selected,
                  }
                : null
            }
            onChange={(selectedOption) =>
              handleChange({
                target: {
                  value: selectedOption?.value,
                },
              })
            }
            options={options.map((item) => ({
              value: item,
              label: item,
            }))}
            placeholder="Select one"
            isSearchable={false}
            styles={{
              container: (base) => ({
                ...base,
                width: window.innerWidth < 640 ? "100%" : "160px",
                maxWidth: "280px",
              }),

              control: (base) => ({
                ...base,
                boxShadow: "none",
                minHeight: "36px",
                height: "36px",
                fontSize: "14px",
                borderColor: "#ccc",
                "&:hover": {
                  borderColor: "#ccc",
                },
              }),

              valueContainer: (base) => ({
                ...base,
                padding: "0 8px",
              }),

              singleValue: (base) => ({
                ...base,
                color: "black",
                fontSize: "14px",
              }),

              indicatorsContainer: (base) => ({
                ...base,
                height: "36px",
              }),

              menu: (base) => ({
                ...base,
                zIndex: 50,
              }),

              menuList: (base) => ({
                ...base,
                maxHeight: "120px",
                padding: 0,
              }),

              option: (base, state) => ({
                ...base,
                padding: "6px 10px",
                fontSize: "13px",
                backgroundColor: state.isFocused ? "#f3f4f6" : "white",
                color: "black",
                cursor: "pointer",
              }),
            }}
          />
        </div>

        <form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 w-full sm:w-auto"
        >
          <input
            type="file"
            ref={fileInputRef}
            accept=".csv,.xlsx"
            required
            onChange={handleFileChange}
            className="w-full sm:w-auto text-sm pl-[45px] md:pl-0"
          />

          <button
            type="submit"
            disabled={loading || !uploadAllowed}
            className={`w-full sm:w-auto flex justify-center items-center text-white text-sm font-semibold py-2 px-4 rounded transition-all duration-300 ${
              loading || !uploadAllowed
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#2A5775] hover:bg-[#2898e2]"
            }`}
          >
            {loading && (
              <svg
                className="mr-2 size-5 animate-spin text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />

                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                />
              </svg>
            )}

            {loading ? "Uploading…" : "Upload"}
          </button>
        </form>
      </div>

      {/* Error Table */}
      {uploadResponse?.incorrect_uploaded_data?.length > 0 && (
        <div className="mt-4">
          <div
            className="bg-[#28526E] p-2 flex justify-center text-sm sm:text-lg font-bold text-white mb-2 cursor-pointer select-none rounded-md"
            onClick={() => setIsErrorTableVisible((prev) => !prev)}
          >
            <span>Incorrect Uploaded Data:</span>
            <span className="ml-2 text-white">
              {isErrorTableVisible ? "▲" : "▼"}
            </span>
          </div>

          {isErrorTableVisible && (
            <div>
              <div className="overflow-auto max-h-[320px] border rounded relative">
                <table className="min-w-full text-xs sm:text-sm text-left whitespace-nowrap">
                  {/* existing table code */}
                </table>
              </div>

              <p className="mt-2 p-3 bg-yellow-50 border-l-4 border-yellow-400 text-red-700 text-xs sm:text-sm rounded">
                <span className="font-bold mr-1">Attention:</span>
                Errors were found in your file. Please correct only the
                highlighted entries and re-upload the entire file.
              </p>
            </div>
          )}
        </div>
      )}

      {/* Saved Data */}
      <div className="mb-6 mt-6">
        <div
          className="bg-[#28526E] p-2 flex justify-center text-sm sm:text-lg font-bold text-white mb-2 cursor-pointer select-none rounded-md"
          onClick={() => setIsTableVisible((prev) => !prev)}
        >
          <span>Uploaded Data (Saved):</span>
          <span className="ml-2 text-white">{isTableVisible ? "▲" : "▼"}</span>
        </div>

        {isTableVisible ? (
          isFetching ? (
            <div className="grid items-center justify-center w-full h-full">
              <Loader />
            </div>
          ) : (
            <div className="overflow-auto max-h-[380px] w-full border rounded">
              {savedData && savedData.length > 0 ? (
                <MaterialReactTable
                  columns={columns}
                  data={savedData}
                  initialState={{
                    density: "compact",
                  }}
                  muiTableContainerProps={{
                    sx: {
                      overflowX: "auto",
                    },
                  }}
                  muiTableHeadCellProps={{
                    sx: {
                      position: "sticky",
                      top: 0,
                      background: "#2A5775",
                      color: "white",
                      fontWeight: "bold",
                      zIndex: 10,
                      whiteSpace: "nowrap",
                      fontSize: {
                        xs: "11px",
                        sm: "14px",
                      },
                      "& .Mui-TableHeadCell-Content": {
                        justifyContent: "center !important",
                      },
                    },
                  }}
                  muiTableBodyCellProps={{
                    sx: {
                      textAlign: "center",
                      fontSize: {
                        xs: "11px",
                        sm: "14px",
                      },
                    },
                  }}
                />
              ) : (
                <p className="flex justify-center py-4 text-sm">
                  No data available
                </p>
              )}
            </div>
          )
        ) : null}
      </div>

      {/* Download */}
      <div
        className="bg-[#28526E] p-2 sm:p-3 flex justify-center text-sm sm:text-lg font-bold text-white mb-2 cursor-pointer select-none rounded-md text-center"
        onClick={handleDownload}
      >
        <span>Click to Download Sample File</span>
      </div>

      {/* Note */}
      <span className="text-sm sm:text-base">
        <span className="font-bold">Note :</span> WAR Score Data can only be
        uploaded in
        <span className="font-bold"> April</span> and
        <span className="font-bold"> October</span> month
      </span>
    </div>
  );
};

export default DealerDataUpload;
